import axios from 'axios';
import authHeader from '../../../helpers/jwt-token-access/auth-token-header';
import { ShowNotification, GetFilterString } from '../../../helpers/general/generalHelpers';
import { appConfig } from '../../../config/config';

// function saveCaseStudy(values, history, setLoader) {
//   const CaseStudyId = values._id ? values._id : values.id ? values.id : '';
//   let type = CaseStudyId ? 'put' : 'post';
//   let url = `/question${questionId ? '/' + questionId : ''}`;
//   axios[type](url, values, { headers: authHeader() })
//     .then((data) => {
//       const messageType = type === 'post' ? 'added' : 'updated';
//       ShowNotification({
//           type: 'success',
//           message: data.message || `Question has been ${messageType} successfully!`
//       });
//       history.goBack()
//     })
//     .catch((error) => {
//       console.error(error.response);
//       const message =
//         error && error.response && error.response.data
//           ? error.response.data.message
//           : 'There was an error adding question, please try again!';
//       ShowNotification({ type: 'error', message });
//       throw error;
//     })
//     .finally(() => {
//       setLoader(false);
//     });
// }

function getCaseStudies(pageNumber, filters, pageSize = appConfig.RecordsPerPage) {
  let filterString = GetFilterString(filters);
  return axios.get(`/case-studies?pageNumber=${pageNumber}&pageSize=${pageSize}${filterString}`, {
    headers: authHeader()
  });
}

function deleteCaseStudies(id) {
  return axios.delete(`/case-studies/${id}`, {
    headers: authHeader()
  });
}

function getCaseStudy(id) {
  return axios.get('/case-studies/' + id, { headers: authHeader() });
}

function getQuestion (id){
  return axios.get('/case-studies/' + id, { headers: authHeader() });
}

function saveQuestion (values, history, setLoader){
  const questionId = values._id ? values._id : values.id ? values.id : '';
  let type = questionId ? 'put' : 'post';
  let url = `/question${questionId ? '/' + questionId : ''}`;
  axios[type](url, values, { headers: authHeader() })
    .then((data) => {
      const messageType = type === 'post' ? 'added' : 'updated';
      ShowNotification({
          type: 'success',
          message: data.message || `Question has been ${messageType} successfully!`
      });
      history.goBack()
    })
    .catch((error) => {
      console.error(error.response);
      const message =
        error && error.response && error.response.data
          ? error.response.data.message
          : 'There was an error adding question, please try again!';
      ShowNotification({ type: 'error', message });
      throw error;
    })
    .finally(() => {
      setLoader(false);
    });
}

function updateCaseStudy(questionId,values){
  let type =  'put';
  let url = `/case-studies${questionId ? '/' + questionId : ''}`;
  axios[type](url, values, { headers: authHeader() })
    .then((data) => {
      const messageType = type === 'post' ? 'added' : 'updated';
      ShowNotification({
          type: 'success',
          message: data.message || `CaseStudy has been ${messageType} successfully!`
      });
      // history.goBack()
    })
    .catch((error) => {
      console.error(error.response);
      const message =
        error && error.response && error.response.data
          ? error.response.data.message
          : 'There was an error adding question, please try again!';
      ShowNotification({ type: 'error', message });
      throw error;
    })
    .finally(() => {
      // setLoader(false);
    });
}

function addNewCaseStudy (values,history){
  let type =  'post';
  let url = `/case-studies`;
  axios[type](url, values, { headers: authHeader() })
    .then((data) => {
      const messageType ='added';
      ShowNotification({
          type: 'success',
          message: data.message || `CaseStudy has been ${messageType} successfully!`
      });
      history.goBack()
    })
    .catch((error) => {
      console.error(error.response);
      const message =
        error && error.response && error.response.data
          ? error.response.data.message
          : 'There was an error adding question, please try again!';
      ShowNotification({ type: 'error', message });
      throw error;
    })
    .finally(() => {
      // setLoader(false);
    });
}

// export { getCaseStudies, getCaseStudy, saveCaseStudy };
export { getCaseStudies, getCaseStudy ,getQuestion,saveQuestion,updateCaseStudy,addNewCaseStudy,deleteCaseStudies};
